import { XMLHttpRequestExtended } from '@shared/http/interfaces/request-event.interface';
import { extractContentType } from '@shared/http/utils/extract-content-type';
import { getHttpVersion } from '@shared/http/utils/get-http-version';
import { postEventMessage, sendErrorToSentry } from '@shared/sentry';

export function xhrInjection(): void {
  const XHR: XMLHttpRequestExtended = XMLHttpRequest.prototype;
  const send = XHR.send;
  const open = XHR.open;
  const setRequestHeader = XHR.setRequestHeader;

  XHR.open = function (method, url) {
    try {
      this._coachBotCustomFields = {};
      this._coachBotCustomFields.method = method;
      this._coachBotCustomFields.url = url;
      this._coachBotCustomFields.requestHeaders = {};
      this._coachBotCustomFields.startDateTime = new Date();
    } catch (e) {
      sendErrorToSentry({ error: e });
    }
    // @ts-ignore
    return open.apply(this, arguments);
  };

  XHR.setRequestHeader = function (header, value) {
    try {
      this._coachBotCustomFields.requestHeaders[header] = value;
    } catch (e) {
      sendErrorToSentry({ error: e });
    }
    // @ts-ignore
    return setRequestHeader.apply(this, arguments);
  };

  XHR.send = function (postData) {
    const customFields = { ...this._coachBotCustomFields };
    this.addEventListener('load', function (this: XMLHttpRequestExtended) {
      try {
        const durationInMs = new Date().getTime() - customFields.startDateTime.getTime();
        const responseContentType = extractContentType(this.getResponseHeader('content-type'));

        postEventMessage({
          pageUrl: window.location.href,
          request: {
            body: postData,
            durationInMs,
            httpVersion: getHttpVersion(),
            method: customFields.method,
            startDateTime: customFields.startDateTime.toISOString(),
            url: customFields.url,
          },
          response: {
            body: this.response,
            contentType: responseContentType ? responseContentType : undefined,
            status: this.status,
          },
        });
      } catch (e) {
        sendErrorToSentry({ error: e });
      }
    });

    // @ts-ignore
    return send.apply(this, arguments);
  };
}
